import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const CheckRow = styled.div`
  background-color: ${(props) => props.theme.backgroundLighter};
  border-radius: 4px;
  margin: 5px 0;
  display: flex;
  padding: 15px;
`;

export const AgentBox = styled.div`
  margin-left: 10px;
`;

export const ToggleAgentsButton = styled.button`
  width: 100%;
  display: block;
  color: ${(props) => props.theme.primary};
  text-decoration: underline;
  font-size: 16px;
  margin: 30px 0;
  transition: 300ms all;

  &:hover {
    color: ${(props) => props.theme.backgroundMid};
  }
`;

export const MoreAgentBox = styled.div`
  background-color: ${(props) => props.theme.backgroundLighter};
  border-radius: 4px;
  padding: 5px 0;
`;

export const SubmitButton = styled.div`
  display: none;

  @media (${laptopMediumMax}) {
    display: block;
  }

  @media (${mobileXXLargeMax}) {
    position: sticky;
    bottom: 70px;
    background-color: ${(props) => props.theme.background};
    margin: 0 -15px;
    padding: 5px 15px 15px;
  }
`;
